// extracted by mini-css-extract-plugin
module.exports = {"message":"_3Os3qJP5","is-error":"q3FPZp_F","is-success":"_1CWtjdK7"};